import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Inject,
    Renderer2,
    OnInit,
} from "@angular/core";

import { MediaQueryOption } from "@hermes/aphrodite/media-picture";

import {
    BlockMediaDeprecated,
    ParagraphTypeDeprecated,
} from "@hermes/api-model-editorial";

import {
    SHOULD_PRELOAD_MEDIA,
    CHAPTERS_PARAGRAPH,
    IS_FIRST_PARAGRAPH,
} from "../../core";

@Component({
    selector: "h-block-media",
    templateUrl: "./block-media.component.html",
    styleUrls: ["./block-media.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockMediaComponent implements OnInit {
    public mediaOptions = getMediaOptionsByMediaTypeDeprecated(
        this.blockMedia.type,
    );
    public blockMediaClass?: string;
    public isImmersiveBlockMedia: boolean = false;

    constructor(
        @Inject(CHAPTERS_PARAGRAPH) public blockMedia: BlockMediaDeprecated,
        @Inject(SHOULD_PRELOAD_MEDIA) public shouldPreloadMedia: boolean,
        @Inject(IS_FIRST_PARAGRAPH) public isFirstParagraph: boolean,
        private element: ElementRef,
        private renderer: Renderer2,
    ) {}

    public ngOnInit(): void {
        if (
            this.blockMedia.whiteBackground &&
            this.blockMedia.type === "block_standard_media"
        ) {
            this.renderer.addClass(
                this.element.nativeElement,
                "white-background",
            );
        }

        this.isImmersiveBlockMedia =
            this.isFirstParagraph &&
            this.blockMedia.type === ParagraphTypeDeprecated.blockFullHeroMedia;

        this.blockMediaClass = this.isImmersiveBlockMedia
            ? "block-immersive-media"
            : this.blockMedia.type.replace(/_/g, "-");
    }
}

export const getMediaOptionsByMediaTypeDeprecated = (
    blockMediaType: ParagraphTypeDeprecated,
) =>
    blockMediaType === ParagraphTypeDeprecated.blockStandardMedia
        ? blockStandardPosterOptionsDeprecated
        : undefined;

export const blockStandardPosterOptionsDeprecated: MediaQueryOption[] = [
    {
        size: "xsmall",
        mediaQuery: "(min-width: 320px) and (max-width: 414px)",
        width: 414,
    },
    {
        size: "small",
        mediaQuery: "(min-width: 415px) and (max-width: 670px)",
        width: 670,
    },
    {
        size: "medium",
        mediaQuery: "(min-width: 670px) and (max-width: 620px)",
        width: 620,
    },
    {
        size: "large",
        mediaQuery: "(min-width: 620px) and (max-width: 640px)",
        width: 640,
    },
    {
        size: "xlarge",
        mediaQuery: "(min-width: 640px) and (max-width: 960px)",
        width: 960,
    },
    { size: "xxlarge", mediaQuery: "(min-width: 961px)", width: 1920 },
];
